export default "__VITE_ASSET__670e23c1__"